var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: "使用ISF模板",
        visible: _vm.dialogVisible,
        width: "568px",
        "before-close": _vm.cancel,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("BaseTable", {
        attrs: { height: 400, isPager: false, tableData: _vm.tableData },
        scopedSlots: _vm._u([
          {
            key: "opt",
            fn: function (row) {
              return [
                _c(
                  "p",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-around",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.useTpl(row.scope)
                          },
                        },
                      },
                      [_vm._v("使用此模板")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.romoveRow(row.scope)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }